import { DataTable, DataTablePagination } from 'components/common'
import { RowClickedEvent } from '@ag-grid-community/core'
import { useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { fetchPurchaseTimers } from 'utils/api/purchaseTimerApi'
import { PAGE_PURCHASE_TIMER_UPDATE } from 'utils/constants'
import { columns, FILTER_FIELD_PURCHASE_TIMER } from './utils'

interface PurchaseTimerDataTableProps {
  isEditor: boolean
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const PurchaseTimerDataTable = ({
  isEditor,
  loading,
  setLoading,
}: PurchaseTimerDataTableProps) => {
  const [purchaseTimerResponse, setPurchaseTimerResponse] = useState<any>({})

  const navigate = useNavigate()
  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const getPurchaseTimerData = async () => {
    setLoading(true)
    const {
      limit,
      page,
      search,
      [FILTER_FIELD_PURCHASE_TIMER]: filters,
    } = getAllQueries()
    try {
      const { data } = await fetchPurchaseTimers({
        limit: limit || 10,
        page: page || 1,
        search,
        filters,
      })

      setPurchaseTimerResponse({ ...data })
    } catch {
      setPurchaseTimerResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getPurchaseTimerData()
  }, [search])

  const onRowClicked = (event: RowClickedEvent) => {
    if (!isEditor) return
    navigate(`${PAGE_PURCHASE_TIMER_UPDATE.path}/${event.data._id}`)
  }

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : purchaseTimerResponse.docs}
        identifier="_id"
        onRowClicked={isEditor ? onRowClicked : () => {}}
        activeColumns={[]}
      />

      <DataTablePagination
        currentPage={purchaseTimerResponse?.page}
        totalPages={purchaseTimerResponse?.totalPages}
        hasNextPage={purchaseTimerResponse?.hasNextPage}
        hasPrevPage={purchaseTimerResponse?.hasPrevPage}
        limit={purchaseTimerResponse?.limit}
        nextPage={purchaseTimerResponse?.nextPage}
        prevPage={purchaseTimerResponse?.prevPage}
        disabled={loading}
        shouldDisplayTotalPages={false}
        disableGoToLastPage
      />
    </>
  )
}

export default PurchaseTimerDataTable
